import * as React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { LazyMotion, domAnimation } from "framer-motion";
import type { WrapRootElementBrowserArgs } from "gatsby";
import { customTheme } from "./theme";
import "./styles/global.css";
export const WrapRootElement = ({ element }: Pick<WrapRootElementBrowserArgs, 'element'>) => (
    // Or ChakraBaseProvider if you only want to compile the default Chakra theme tokens
    <ChakraProvider theme={customTheme}>
        <LazyMotion features={domAnimation}>
            {element}
        </LazyMotion>
    </ChakraProvider>
)